<template>
  <div class="col-md-2">
    <ul class="insight-chart-legend tooltip">
      <!-- if participant has answered the question then we need to show the lengend -->
      <li>
        <span :style="{ backgroundColor: primaryColor }" class="chart-legend-box"></span>
        <span class="chart-legend-text" @mouseover="upHere = true" @mouseleave="upHere = false">{{ participantName ? (participantName.length > 10 ? participantName.slice(0, 10) + "..." : participantName) : `Me` }}</span>
      </li>
      <!-- End -->
      <div v-if="participantName.length > 10 && upHere">
        <span class="tooltiptext" v-html="participantName"></span>
      </div>
      <li>
        <span :style="{ backgroundColor: colorLegendOthers }" class="chart-legend-box"></span>
        <span class="chart-legend-text">Others</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { shadeColor } from "../../services/utils";
export default {
  props: {
    primaryColor: { type: String, default: "" },
    participantName: { type: String, default: "" }
  },

  data() {
    return {
      colorLegendOthers: shadeColor(this.primaryColor, 30),
      upHere: false
    };
  }
};
</script>
<style scoped lang="scss">
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1;
}

.tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #ffffff;
  color: #a1a1a1;
  text-align: center;
  font-family: Roboto;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 120%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  padding: 5px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
}

.tooltiptext::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
